import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, deleteApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ExcluirParametroLocalidadeRequest } from './types';

// ACTIONS
import {
	excluirParametroLocalidadeSuccess,
	excluirParametroLocalidadeFailure,
} from './actions';

function* excluirParametroLocalidade(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ExcluirParametroLocalidadeRequest } = request;

	const response: ApiResponse = yield call(
		deleteApi,
		token || '',
		PATH_SGU_API,
		`parametros-localidades/${payload.id}`,
	);

	if (response.status === 200) {
		yield put(excluirParametroLocalidadeSuccess(response));
	} else {
		yield put(excluirParametroLocalidadeFailure());
	}
}

export default all([
	takeLatest(Types.EXCLUIR_PARAMETRO_LOCALIDADE, excluirParametroLocalidade),
]);
